<template>
  <div class="scmcc-layout-frame-wraper">
    <div class="scmcc-layout-frame theme-bg-gray-color">
      <CSidebar></CSidebar>
      <div class="scmcc-layout-frame-right" >
        <CHeader></CHeader>
        <HeadTab v-if = "$store.state&&$store.state.scconf_ui.base.tabBar" />
        <div class="scmcc-layout-frame-content"  :class = '{"padding-top-5":($store.state&&$store.state.scconf_ui.base.tabBar)}'>
          <ThirdMenu />
          <div style = "flex:1;overflow:hidden;">
            <component
              v-for="(value, key) in $store.state.dynamicComponent.IFRAME"
              :key="key"
              :is="value"
            ></component>
            <CBreadcrumbs v-if = "!($store.state&&$store.state.scconf_ui.base.tabBar)"></CBreadcrumbs>
            <IframeViews v-show = "iframeViewShow" />
            <keep-alive :include="includes">
              <router-view
                v-show = "!iframeViewShow"
                class="scmcc-layout-frame-router"
                :key="$route.fullPath"
              ></router-view>
            </keep-alive>
            <!-- <keep-alive>
              <router-view
                v-if="$route.meta.keepAlive && $store.state.main.pageCatch"
                class="scmcc-layout-frame-router"
              ></router-view>
            </keep-alive>
            <router-view
              v-if="!$route.meta.keepAlive || !$store.state.main.pageCatch"
              class="scmcc-layout-frame-router"
            ></router-view> -->
            <CBackTop></CBackTop>
          </div>
        </div>
      </div>
      <div class="scmcc-layout-global">
        <component
          v-for="(value, key) in $store.state.dynamicComponent.GLOBAL"
          :key="key"
          :is="value"
        ></component>
      </div>
    </div>
    <div v-if="showAddMessage" id="addMessage">
      <AddMessage @hideMessageView="hideMessageView"></AddMessage>
    </div>
    <Questionnaire />
  </div>
</template>

<script>
import CHeader from '../components/Header/index.vue'
import CSidebar from '../components/Sidebar.vue'
import CBackTop from '../components/BackTop.vue'
import CBreadcrumbs from '../components/Breadcrumbs.vue'
import AddMessage from '../views/AddMessage.vue'
import Cookies from 'js-cookie'
import Questionnaire from '../components/questionnaire.vue'
import { setTimeout } from 'timers';
import HeadTab from '../components/headTab.vue'
import IframeViews from '../views/iframeview/iframeViews.vue'
import ThirdMenu from '../components/Menu/thirdMenu.vue'
export default {
  name: 'layoutDefault',
  components: {
    CHeader,
    CSidebar,
    CBackTop,
    CBreadcrumbs,
    AddMessage,
    Questionnaire,//问卷
    HeadTab,
    IframeViews,//iframe路由视图
    ThirdMenu,
  },
  data() {
    return {
      showAddMessage: false,
    }
  },
  computed: {
    includes(){
      return this.$store.state.main.menus.keepAliveTabs.join(',').split(',')
    },
    iframeViewShow(){
      if(this.$route.meta.linkUrl){
        return true
      }
      return false
    }
  },
  methods: {
    hideMessageView() {
      this.showAddMessage = false
    }
  },
  created() {
    // 清空eventbus
    console.log('global---',this.$store.state.dynamicComponent.GLOBAL)
    this.showAddMessage = this.$route.params.showAddMessage
    this.$eventBus.clean()
    this.$eventBus.on('scmcc/cinVccBarLogout',() => {
      if(!localStorage.user){
        location.reload()
      }
    })
    // 退出业务
    this.$eventBus.on('scmcc/logout', () => {
      let logout = () => {
        this.$http.get('/sctm/auth/logOut').then(() => {
          // 关闭WS
          if (this.$store.state.main.WS) this.$store.state.main.WS.close()
          // 清除用户信息
          this.$store.commit('main/user/clear')
          // 清除cookies
          Cookies.remove('needCheckCode')
          Cookies.remove('JSESSIONID')
          this.$router.push({ query: { logout: true } })
          if(this.$store.state.cincc&&this.$store.state.cincc.cinVccBar){
            this.$store.state.cincc.cinVccBar.unInitial(0)
            setTimeout(()=>{
              location.reload()
            },2000)
          }else{
            location.reload()
          } 
        })
      }
      if (window.softPhoneApi && this.$store.state.scim_ui) {
        window.softPhoneApi.softPhoneOut().then(() => {
          this.$store
            .dispatch('scim_ui/endAllSession') // 退出前先迁出坐席
            .then(() => {
              logout()
            })
            .catch(() => {
              logout()
            })
        })
      } else {
        if (window.softPhoneApi) {
          window.softPhoneApi.softPhoneOut().then(() => {
            logout()
          })
        } else {
          logout()
        }
      }
    })
  }
}
</script>

<style lang="stylus">
.fade-enter-active, .fade-leave-active
  transition opacity 0.5s

.fade-enter, .fade-leave-to
  opacity 0

.scmcc-layout-frame-wraper
  width 100%
  height 100%

.scmcc-layout-frame
  display flex
  width 100%
  height 100%

  .scmcc-layout-frame-right
    display flex
    flex-flow column
    position relative
    flex auto
    width 0
    z-index 0
    .padding-top-5
      padding-top 5px!important

    .scmcc-layout-frame-content
      position relative
      flex auto
      padding 24px
      overflow-y auto
      height 0
      display flex
      width 100%
      height:100%

      .scmcc-layout-frame-router
        width 100%
        height 100%
        overflow-y:auto

  .scmcc-layout-global
    position absolute

#addMessage
  width 100%
  height 100%
  top 0
  left 0
  position fixed
  background rgba(0, 0, 0, 0.5)
  z-index 999
</style>
